import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import { menuToggler } from '@bd/bdcore-utilities';
import ContactModal from './ContactModal';
import { colors, typography } from '../styles';

const styles = css`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 60px 20px 20px 20px;
  overflow-y: scroll;
  z-index: 100;
  display: none;

  &.HeaderMenu-active {
    display: block;
    background:rgba(255,255,255,0);
  }
  .HeaderMenu_menuClose {
    display: block;
    position: absolute;
    right: 16px;
    top: 16px;
    width: 28px;
    height: 28px;
    padding: 0;
    box-sizing: content-box;
    background-image: url('/images/icon-close-red.svg');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 28px 28px;
    background-color: transparent;
    border: 0;
    cursor: pointer;
    z-index: 9;
    @media (min-width: 991px) {
      right: 32px;
      top: 32px;
    }
  }
  .HeaderMenu_menu {
    list-style: none;
    margin: 0;
    padding: 0;
    text-align: left;
    padding:0;
    background: white;
    width: 320px;
    margin-right: auto;
    position: absolute;
    overflow: auto;
    right: 0;
    top: 0;
    bottom: 0;
    padding:60px 20px;
    @media (min-width: 991px) {
      padding:100px 20px;
      width: 420px;
    }
  }
  .HeaderMenu_menuItem {
    list-style: none;
    border-bottom: 1px solid ${colors.color1};
  }
  .HeaderMenu_menuItem:last-child {
    border-bottom:0;
  }
  .HeaderMenu_menuHeading {
    font:700 14px/1 ${typography.SansSerif};
    text-transform: uppercase;
    background-image: url('/images/icon-triangle-red.svg');
    background-position: calc(100% - 16px) center;
    background-repeat: no-repeat;
    background-size: 8px 6px;
    cursor: pointer;
    display: block;
    color:${colors.color2};
    outline:none;
    padding: 15px 0;
    @media (min-width: 991px) {
      font:700 24px/1 ${typography.SansSerif};
      padding: 20px 0;
    }
  }
  .HeaderMenu_menuHeading:last-child {
    border-bottom:0;
  }
  a.HeaderMenu_menuHeading {
    background-image: none;
    padding: 15px 10px;
    outline:none;
  }

  a.HeaderMenu_menuHeading-phone {
    background-image: none;
    padding: 15px 0;
    outline:none;
    color:${colors.color1};
    font-weight: 700;
    font-size:18px;
    color:white;
  }
  .HeaderMenu_subMenu {
    display: none;
    list-style: none;
    margin: 0;
    position: relative;
    padding:0;
  }
  .HeaderMenu_subMenu-active {
    display: block;
  }
  .HeaderMenu_subMenuItem a {
    color: ${colors.color2};
    font:300 16px/1 ${typography.SansSerif};
    padding: 20px;
    display: block;
    transition: all .3s ease;
    border-bottom:rgba(255,255,255,.2);
    text-transform: capitalize;
    text-decoration: none;
    @media (min-width: 991px) {
      font:300 20px/1 ${typography.SansSerif};
    }
    &:hover {
    }
  }
  .Menu_Actions {
    margin:20px 0;
    display: flex;
    flex-flow:row nowrap;
    justify-content: space-around;
    .Menu_Actions-icon {
      width:46%;
      padding-top:46%;
      background:whitesmoke;
      position:relative;
      border-radius:50%;
      @media (min-width: 480px) {
        width:40%;
        padding-top:40%;
      }
      .Menu_Actions-iconInner {
        position:absolute;
        top:0;
        right:0;
        bottom:0;
        left:0;
        display:flex;
        flex-flow:column nowrap;
        justify-content: center;
        text-align: center;
        color:${colors.color1};
        font-size:12px;
        @media (min-width: 991px) {
          font-size:14px;
        }
        img {
          width:36px;
          height:30px;
          margin:0 auto;
          fill:red;
          margin-bottom:5px;
          @media (min-width: 991px) {
            width:48px;
            height:40px;
          }
        }
      }
    }
  }
`;

function HeaderMenu({ isActive, toggleMenu, builder }) {
  return (
    <div className={`${styles} ${isActive ? 'HeaderMenu-active' : ''}`} onClick={toggleMenu} role="presentation">
      <button className="HeaderMenu_menuClose" onClick={toggleMenu} />
      <ul className="HeaderMenu_menu">
        <li className="HeaderMenu_menuItem">
          <Link onClick={toggleMenu} name="communities" className="HeaderMenu_menuHeading">Communities</Link>
        </li>
        <li className="HeaderMenu_menuItem">
          <Link onClick={toggleMenu} name="photo-gallery" className="HeaderMenu_menuHeading">Galleries</Link>
        </li>
        <li className="HeaderMenu_menuItem">
          <Link onClick={toggleMenu} name="about-us" className="HeaderMenu_menuHeading">About Us</Link>
        </li>
        <li className="HeaderMenu_menuItem">
          <Link onClick={toggleMenu} name="hoa-portal" className="HeaderMenu_menuHeading">HOA Portal</Link>
        </li>
        <li className="HeaderMenu_menuItem">
          <Link onClick={toggleMenu} name="contact-us" className="HeaderMenu_menuHeading">Contact Us</Link>
        </li>
        <li className="HeaderMenu_menuItem">
          <Link onClick={toggleMenu} name="sell-us-your-land" className="HeaderMenu_menuHeading">Sell Us Your Land</Link>
        </li>
        <li className="HeaderMenu_menuItem">
          <Link onClick={toggleMenu} name="for-builders" className="HeaderMenu_menuHeading">For Builders</Link>
        </li>
        <li className="HeaderMenu_menuItem">
          <Link onClick={toggleMenu} name="rentals" className="HeaderMenu_menuHeading">Rentals</Link>
        </li>
        <li className="HeaderMenu_menuItem">
          <a onClick={toggleMenu} href="https://hosted.usiopay.com/63f9d750-4435-43f1-abfb-8c042931ed39" target="_blank" rel="noopener noreferrer" className="HeaderMenu_menuHeading">Pay HOA Dues</a>
        </li>
        {/* <li className="HeaderMenu_menuItem">
          <span tabIndex={0} role="button" className="HeaderMenu_menuHeading"
          nClick={activateMenu('galleries')}>Galleries</span>
          <ul className={`${isActiveMenu('galleries') ?
          'HeaderMenu_subMenu-active' : ''} HeaderMenu_subMenu`}>
            <li className="HeaderMenu_subMenuItem"><Link onClick={toggleMenu}
            name="photo-gallery">Photo Gallery</Link></li>
            <li className="HeaderMenu_subMenuItem"><Link onClick={toggleMenu}
            name="video-gallery">Video Gallery</Link></li>
          </ul>
        </li> */}
        <li>
          <ul className="Menu_Actions list-unstyled">
            <li className="Menu_Actions-icon">
              <a href={`tel:${get(builder, 'telephone').replace(/[^0-9]/g, '')}`} className="Menu_Actions-iconInner"><img src="/images/icon-phone-red.svg" alt="" />{get(builder, 'telephone').replace(/\s-\s/, '-')}</a>
            </li>
            {/* <li className="Menu_Actions-icon">
              <a href={`sms:${get(builder, 'text_phone').replace(/[^0-9]/g, '')}`}
               className="Menu_Actions-iconInner"><img src="/images/icon-sms-red.svg"
                alt="" />TEXT</a>
            </li> */}
            <li className="Menu_Actions-icon">
              <ContactModal>
                <div className="Menu_Actions-iconInner"><img src="/images/icon-email-red.svg" alt="" />EMAIL</div>
              </ContactModal>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  );
}

HeaderMenu.propTypes = {
  isActive: PropTypes.bool.isRequired,
  toggleMenu: PropTypes.func.isRequired,
  // isActiveMenu: PropTypes.func.isRequired,
  // activateMenu: PropTypes.func.isRequired,
  builder: PropTypes.object.isRequired,
};

export default menuToggler(HeaderMenu);



// WEBPACK FOOTER //
// ./src/components/HeaderMenu.js